import "./media-bank-block.scss";

(function () {
    if (document.querySelectorAll(".js-media-bank-block").length > 0) {
        const mediaBankBlock = {
            init: () => {
                mediaBankBlock.toggleDownload();
                mediaBankBlock.closeDownload();
            },
            toggleDownload: () => {
                const downloadBtns = document.querySelectorAll("#show__download");
  
                downloadBtns.forEach((downloadBtn) => {

                    downloadBtn.addEventListener("click", (e) => {
                        const toggleDiv = e.currentTarget.nextElementSibling;

                        if (toggleDiv.style.display === 'none' || toggleDiv.style.display === '') {
                            toggleDiv.style.display = 'inline-block';
                        }
                        else {
                            toggleDiv.style.display = 'none';
                        }

                    })
                })
        
            },

            closeDownload: () => {
                const downloadZips = document.querySelectorAll("#toggle__download");
                   downloadZips.forEach((downloadZip) => {
                       downloadZip.addEventListener("click", (e) => {
                           e.currentTarget.style.visibility = 'hidden';
                       })
                   });
            }


        };

        mediaBankBlock.init();
    }


})();